exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "body{margin:0;padding:0;overflow:hidden;font-family:sans-serif}.routeContainer{flex-direction:row;display:flex;height:100%;overflow:hidden}.nav{background-color:#7b3293;min-width:200px}.nav li{color:#fff;font-weight:300;font-size:14px}.nav li:hover{background-color:#ee4807!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/index.scss
// module id = 280
// module chunks = 0